var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSelf(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_190985",
    "data-name": "Group 190985",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 28,
    height: 30.333,
    viewBox: "0 0 28 30.333",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_149271",
    "data-name": "Rectangle 149271",
    width: 28,
    height: 30.333,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_176298",
    "data-name": "Group 176298",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_173775",
    "data-name": "Path 173775",
    d: "M22.07,17.5a8.75,8.75,0,1,0-8.75-8.75,8.759,8.759,0,0,0,8.75,8.75m0-15.166A6.417,6.417,0,1,1,15.653,8.75,6.424,6.424,0,0,1,22.07,2.333",
    transform: "translate(-8.07 0)",
    fill: "#f26422"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_173776",
    "data-name": "Path 173776",
    d: "M20.99,43.271a10.871,10.871,0,0,1-2.26,1.461,11.684,11.684,0,0,1,6.878,9.484H2.392A11.684,11.684,0,0,1,9.27,44.732a10.871,10.871,0,0,1-2.26-1.461A14,14,0,0,0,0,55.382v1.167H28V55.382a14,14,0,0,0-7.01-12.111",
    transform: "translate(0 -26.216)",
    fill: "#f26422"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelf);
export default __webpack_public_path__ + "static/media/self.3e2281b1f9392bebae2b445351977a6a.svg";
export { ForwardRef as ReactComponent };